import { Page } from '@/components';
import { Flex, Heading, useTableProps } from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';
import CdpsTable from './CdpsTable';
import TextSearchFilter from '@/components/TextSearchFilter/TextSearchFilter';

export default function AllVaultsPage() {
  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-debt',
    filtersDebounceTime: 250,
    initialFilters: {
      textSearch: ''
    }
  });

  return (
    <Page title={<Heading size="1">CDPs</Heading>}>
      <HistoricTabs />
      <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
        <TextSearchFilter
          filters={filters}
          placeholder="Search by CDP or URN"
        />
      </Flex>
      <CdpsTable
        pagination={pagination}
        sorting={sorting}
        appliedFilter={filters.filtersApplied['textSearch']}
      />
    </Page>
  );
}
